var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { BwElement } from './base/bw-element.js';
let BwToggle = class BwToggle extends BwElement {
    constructor() {
        super(...arguments);
        this.checked = false;
        this.disabled = false;
        this.label = '';
        // Accessible name for label-less toggles. Callers set `aria-label` on the
        // HOST, but the switch AT actually focuses is `.bw-toggle-native` — an
        // inner <input role="switch"> wrapped by a <label> with no accessible name
        // of its own. Redeclaring `ariaLabel` as a Lit property (normally inherited
        // from ARIAMixin on HTMLElement) lets us observe the attribute and forward
        // it to the native input. `reflect: true` keeps it on the host attribute
        // too, so existing `[aria-label]` queries on the host still work.
        this.ariaLabel = null;
    }
    _onChange(e) {
        this.checked = e.target.checked;
        this.dispatchEvent(new CustomEvent('bw-toggle-change', {
            detail: { checked: this.checked }, bubbles: true, composed: true,
        }));
    }
    render() {
        return html `
      <label class="bw-toggle-row">
        ${this.label ? html `<span class="bw-toggle-label">${this.label}</span>` : nothing}
        <input class="bw-toggle-native" type="checkbox" role="switch"
          aria-checked=${this.checked ? 'true' : 'false'}
          aria-label=${this.ariaLabel ?? nothing}
          .checked=${this.checked} ?disabled=${this.disabled}
          @change=${this._onChange}>
        <span class="bw-toggle-track" aria-hidden="true"><span class="bw-toggle-knob"></span></span>
      </label>
    `;
    }
};
__decorate([
    property({ type: Boolean, reflect: true })
], BwToggle.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwToggle.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], BwToggle.prototype, "label", void 0);
__decorate([
    property({ type: String, attribute: 'aria-label', reflect: true })
], BwToggle.prototype, "ariaLabel", void 0);
BwToggle = __decorate([
    customElement('bw-toggle')
], BwToggle);
export { BwToggle };
//# sourceMappingURL=bw-toggle.js.map